import { differenceInCalendarDays } from "date-fns"

const calculateDaysToArrival = (startDate: Date | null): number => {
  if (!startDate) return 0
  return differenceInCalendarDays(startDate, new Date())
}

export default calculateDaysToArrival
